import { useContext as t } from "react";
import { MultiSelectDropdownMenuContext as e } from "./index.es2487.js";
function r() {
  return t(e);
}
export {
  r as useMultiselectContext
};
//# sourceMappingURL=index.es5614.js.map
